import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { Check } from "lucide-react";

const BG =
  "https://images.unsplash.com/photo-1656855566586-65a283468fb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxoaWdod2F5JTIwbW90aW9uJTIwYmx1ciUyMGJsYWNrJTIwd2hpdGUlMjBuaWdodCUyMHRyYW5zcG9ydHxlbnwwfHx8fDE3ODkxMzg1NDN8MA&ixlib=rb-4.1.0&q=85&w=1800";

const includes = [
  "Load Searching",
  "Rate Negotiation Support",
  "Broker Communication",
  "Load Planning",
  "Paperwork Assistance",
  "Weekly Revenue Summary",
];

export const Pricing = () => (
  <section id="pricing" className="relative py-28 sm:py-36 overflow-hidden" data-testid="pricing-section">
    <div className="absolute inset-0">
      <img src={BG} alt="" className="w-full h-full object-cover grayscale opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B0B0B] via-[#0B0B0B]/70 to-[#0B0B0B]" />
    </div>

    <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-neutral-500 mb-4">
            Pricing — Simple By Design
          </p>
          <h2 className="font-display font-bold uppercase tracking-tight leading-none text-3xl sm:text-5xl lg:text-6xl mb-6">
            Full-service
            <br />
            dispatch.
          </h2>
          <p className="text-neutral-400 leading-relaxed max-w-md">
            Straightforward pricing for owner-operators who want professional dispatch
            assistance. No contracts, no upfront fees, no forced loads.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="border border-white/15 bg-[#0B0B0B]/70 backdrop-blur-sm p-8 sm:p-12" data-testid="pricing-card">
            <div className="flex items-end gap-2">
              <motion.span
                initial={{ opacity: 0, scale: 0.85 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                className="font-display font-extrabold leading-none text-[7rem] sm:text-[9rem]"
                data-testid="pricing-rate"
              >
                9<span className="text-neutral-500">%</span>
              </motion.span>
            </div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-neutral-400 mt-2 mb-8">
              of gross load revenue — only on loads we dispatch
            </p>
            <ul className="grid sm:grid-cols-2 gap-x-6">
              {includes.map((item) => (
                <li
                  key={item}
                  className="flex items-center gap-3 py-3 border-b border-white/10 text-sm text-neutral-300"
                >
                  <Check size={14} className="text-white shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
            <p className="mt-8 text-neutral-500 text-sm">
              You keep <span className="text-white font-semibold">91%</span> of every dollar your truck earns.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
